import { __assign, __rest } from "tslib";
import React from 'react';
import Box from './Box';
/** @type {any} */
var Position = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Box, __assign({ position: "relative", ref: ref }, props), children));
});
export default Position;
